<template>
  <component
    :is="componentContext.is"
    v-bind="componentContext.bind"
    class="p-9 notice-default"
    @click="$emit('click')"
  >
    <bim-text
      type=main
      bold
      class="notice-default__title"
    >
      {{ notice.title }}
    </bim-text>
    <bim-text
      v-if="notice.text"
      type=medium
      class="mt-6 notice-default__text"
    >
      {{ notice.text }}
    </bim-text>
  </component>
</template>

<script>
import { get } from 'lodash'
import bimText from '@/components/text/bimText/bimText.vue'

export default {
  name: 'NoticeRegion',
  components: {
    bimText
  },
  props: {
    /**
     * Объект уведомления
     */
    notice: Object
  },
  computed: {
    componentContext () {
      const urlTransition = get(this.notice, 'parameters.urlTransition')
      const urlTarget = get(this.notice, 'parameters.urlTarget')
      const urlRel = get(this.notice, 'parameters.urlRel')
      const type = get(this.notice, 'parameters.type')

      if (type === 'transition' && urlTransition) {
        return {
          is: 'a',
          bind: {
            href: urlTransition,
            target: urlTarget || '_blank',
            rel: Object
              .entries(urlRel || { nofollow: true })
              .map(([label, value]) => value ? label : null)
              .filter(Boolean)
              .join(' ')
          }
        }
      }

      return {
        is: 'div',
        bind: {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.notice-default {
  display: block;
  height: 100%;
  text-decoration: none;
  color: inherit;

  .notice-default__title {
    color: $primary-color;
  }

  .notice-default__title,
  .notice-default__text {
    word-break: break-word;
  }
}
</style>
